import { useEffect } from 'react';
import { useAppDispatch } from '../../../store';
import { setAuthToken } from '../state/authSlice';

export const useCheckToken = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const localToken = localStorage.getItem('token');
    if (localToken) {
      dispatch(setAuthToken(localToken));
    }
  }, []);
};
